import React from "react";
import CapacityFilter from "./CapacityFilter";
//import Context from "../../../context/Context";
import LevelFilter from "./LevelFilter";
import * as component from "../../util/component";

export default class Filter extends React.Component {

  capacityComponent;
  levelComponent;

  constructor(props) {
    super(props);
    this.state = component.newState({
    });
  }

  componentDidMount() {
    if (this.props.onMount) this.props.onMount(this);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const criteria = this.props.criteria;
    return (
      <div className="i-filter-form" style={{minWidth: "200px", padding: "0.5rem"}}>
        <CapacityFilter
          capacity={criteria.filter.capacity}
          items={this.props.items}
          onMount={c => this.capacityComponent = c} />
        <LevelFilter items={this.props.items}
          facilityId={criteria.filter.facilityId}
          levelId={criteria.filter.levelId}
          siteId={criteria.filter.siteId}
          equipments={criteria.filter.equipments}
          onMount={c => this.levelComponent = c} />
      </div>
    );
  }

  validate(criteria) {
    let ok = true;
    let filter = {
      siteId: null,
      facilityId: null,
      levelId: null,
      capacity: null,
      equipments: []
    };
    if (ok) ok = this.capacityComponent.validate(filter);
    if (ok) ok = this.levelComponent.validate(filter);
    if (ok) {
      criteria.filter = filter;
    }
    return ok;
  }

}
